import { reactive, readonly, watch } from "vue";

const state = reactive({
    idArray: favouritesCookieExists(),
});

function favouritesCookieExists() {
    const allCookies = document.cookie.split(";");
    const favouritesCookie = allCookies.find((x) =>
        x.trim().startsWith("favourites=")
    );
    if (favouritesCookie) return JSON.parse(favouritesCookie.split("=")[1]);
    return [];
}

function updateFavouritesCookie(favouritesIdArray) {
    const arrayAsString = JSON.stringify(favouritesIdArray);
    document.cookie = `favourites=${arrayAsString};path=/`;
    state.idArray.length = 0;
    state.idArray.push(...favouritesCookieExists());
}

export function addModelToFavourites(modelId) {
    modelId = +modelId;
    const favouritesIdArray = favouritesCookieExists();
    if (!favouritesIdArray.length) return updateFavouritesCookie([modelId]);
    if (favouritesIdArray.includes(modelId))
        return removeModelFromFavourites(modelId);
    const newFavouritesIdArray = favouritesIdArray.concat([modelId]);
    updateFavouritesCookie(newFavouritesIdArray);
}

function removeModelFromFavourites(modelId) {
    const newFavouritesIdArray = state.idArray.filter((x) => x !== modelId);
    updateFavouritesCookie(newFavouritesIdArray);
}

function updateAllStaticCards() {
    const staticCards = document.querySelectorAll("[data-favourites-id]");
    staticCards.forEach((x) => {
        const id = +x.dataset.favouritesId;
        if (state.idArray.includes(id))
            return x.querySelector("svg").classList.add("added-to-favourites");
        x.querySelector("svg").classList.remove("added-to-favourites");
    });
}

export function watchFavourites() {
    watch(
        state.idArray,
        (newFavs) => {
            const el = document.querySelector(".favourite-item");
            el.innerText = newFavs.length;
            updateAllStaticCards();
        },
        { immediate: true }
    );
}

export default readonly(state);
